module.exports = __webpack_public_path__ + "img/PauseButtonNew.a2787a28.png";